import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { ShoppingBag, Menu, X, Instagram } from "lucide-react";
import { useCart } from "@/context/CartContext";

export const Header = () => {
  const { itemCount, setIsOpen } = useCart();
  const [menuOpen, setMenuOpen] = useState(false);

  const navLink = ({ isActive }) =>
    `text-sm font-medium transition-colors ${isActive ? "text-[#D81B60]" : "text-[#2D0A22] hover:text-[#D81B60]"}`;

  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-40 w-full bg-[#FFFBFB]/80 backdrop-blur-xl border-b border-[#F4D8E2]"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-2">
          <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#F8BBD0] to-[#D81B60] flex items-center justify-center text-white font-serif text-lg">S</div>
          <div className="leading-tight">
            <div className="font-serif text-lg font-semibold text-[#2D0A22]">Sugandhi</div>
            <div className="text-[10px] uppercase tracking-widest text-[#8E6377] -mt-0.5">Flowers · Vita</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <NavLink to="/" className={navLink} data-testid="nav-home">Shop</NavLink>
          <NavLink to="/custom" className={navLink} data-testid="nav-custom">Custom Bouquet</NavLink>
          <NavLink to="/gallery" className={navLink} data-testid="nav-gallery">Instagram</NavLink>
          <NavLink to="/reviews" className={navLink} data-testid="nav-reviews">Reviews</NavLink>
          <NavLink to="/about" className={navLink} data-testid="nav-about">About</NavLink>
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="https://www.instagram.com/sugandhiflowermerchant?igsh=dDc4dW1sYTVpejdt&utm_source=qr" target="_blank" rel="noreferrer"
            data-testid="header-instagram"
            className="hidden md:inline-flex w-9 h-9 items-center justify-center rounded-full text-[#8E6377] hover:text-[#D81B60] hover:bg-[#FCE4EC]"
          >
            <Instagram size={18} />
          </a>
          <button
            data-testid="open-cart-button"
            onClick={() => setIsOpen(true)}
            className="relative w-10 h-10 rounded-full bg-[#FCE4EC] text-[#D81B60] hover:bg-[#F8BBD0] flex items-center justify-center transition-colors"
            aria-label="Open cart"
          >
            <ShoppingBag size={18} />
            {itemCount > 0 && (
              <span data-testid="cart-count-badge" className="absolute -top-1 -right-1 bg-[#D81B60] text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] px-1 flex items-center justify-center">
                {itemCount}
              </span>
            )}
          </button>
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden w-10 h-10 rounded-full bg-[#FCE4EC] text-[#D81B60] flex items-center justify-center"
            onClick={() => setMenuOpen(v => !v)}
          >
            {menuOpen ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-[#F4D8E2] bg-[#FFFBFB]" data-testid="mobile-menu">
          <div className="px-4 py-3 flex flex-col gap-3">
            <NavLink to="/" onClick={() => setMenuOpen(false)} className={navLink}>Shop</NavLink>
            <NavLink to="/custom" onClick={() => setMenuOpen(false)} className={navLink}>Custom Bouquet</NavLink>
            <NavLink to="/gallery" onClick={() => setMenuOpen(false)} className={navLink}>Instagram</NavLink>
            <NavLink to="/reviews" onClick={() => setMenuOpen(false)} className={navLink}>Reviews</NavLink>
            <NavLink to="/about" onClick={() => setMenuOpen(false)} className={navLink}>About</NavLink>
          </div>
        </div>
      )}
    </header>
  );
};
